module.exports = __webpack_public_path__ + "img/zd-new-3.db3a33fe.svg";